import React, { useState } from "react";

export default function CommandBar({
    isAdmin,
    isAssigned,
    assignedTableNumber,
    cart = [],
    t,
    setIsModalOpen,
    setIsCartModalOpen,
    closeTable,
    infoModalPreProcess
}) {
    const [isOpen, setIsOpen] = useState(true);
    return (
        <div className={"position-fixed ordinaContainer py-1 px-2 px-sm-0 " + (isAdmin ? "isAdmin " : "") + (isOpen ? "isOpen" : "")}>

            <button
                onClick={() => setIsOpen(!isOpen)}
                className="toggle-button position-absolute end-0 top-0 mt-2 me-2 d-md-none"
                title={isOpen ? t('hideCommands') : t('showCommands')}
            >
                <i className={`bi ${isOpen ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
            </button>

            {/* Se utente non admin e assegnato */}
            {!isAdmin && isAssigned && (
                <div className="tableNumber d-flex justify-content-center">
                    {t('table')} {assignedTableNumber}
                    <span onClick={infoModalPreProcess} className="bi bi-info-circle ms-2 info" role="button"></span>
                </div>
            )}

            {/* Se utente admin */}
            {isAdmin && (
                <div className="tableNumber d-flex justify-content-center">
                    <span onClick={infoModalPreProcess} className="bi bi-info-circle ms-2 info" role="button"></span>
                </div>
            )}

            {/* Bottoni */}
            {(isAssigned || isAdmin) && (
                <div
                    className="transition-all overflow-hidden"
                    style={{
                        maxHeight: isOpen ? "1000px" : "0",
                        opacity: isOpen ? 1 : 0,
                        transition: "all 0.4s ease-in-out",
                    }}
                >
                    <div className="buttonBox me-sm-2 mt-2">
                        <button onClick={() => setIsModalOpen(true)} type="button" className="btn btn-primary changeMenu">
                            <i className="bi bi-arrow-repeat me-2"></i>
                            {t('changeMenu')}
                        </button>

                        {!isAdmin && (
                            <button onClick={() => setIsCartModalOpen(true)} type="button" className="ms-md-2 btn btn-primary changeMenu">
                                <i className="bi bi-cart me-2"></i>
                                {t('cart')}
                            </button>
                        )}

                        {!isAdmin && isAssigned && (
                            <button onClick={closeTable} type="button" className="ms-2 btn btn-danger changeMenu closeTableCustomer">
                                <i className="bi bi-box-arrow-right me-2"></i>
                                {t('closeTable')}
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
